import React, {Component} from 'react';
import couterpart from 'counterpart';
import { IoMdSend } from 'react-icons/io';

import AuthenticationService from '../services/AuthenticationService';
import {ICON_COLOR} from '../icon';

import '../css/formStyle.css';

import TalkService from '../services/TalkService';
import UserDataService from '../services/UserDataService';

class TalkDetails extends Component {
    constructor() {
        super();
        this.state = {
            msg: '',
            msgTo: '',
            selectOptions: []
        } 
    };


    componentDidMount () {
        this.setState({
            workOrderId: this.props.workOrderId
        })

        UserDataService.retrieveUsers().then(data => {
            var len = data.length;
            var selectOptions = [];
            if (AuthenticationService.isDesigner()){
                for(let i=0; i<len; i++){
                    // if ((data[i].roleName === 'SERVICE' || data[i].roleName === 'ADMIN') && (data[i].workingShop === this.props.workingShop)){
                    if ((data[i].roleName === 'SERVICE' || data[i].roleName === 'ADMIN')){
                        selectOptions.push({id:data[i].id, label: data[i].firstName, value: data[i].id, role: data[i].roleName})
                    }
                }
            } else {
                for(let i=0; i<len; i++){
                    selectOptions.push({id:data[i].id, label: data[i].firstName, value: data[i].id, role: data[i].roleName})
                }                
            }
            this.setState({selectOptions: selectOptions});
        });
    }

    handleMsgChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            msg: newValue                  
        }));
    }

    handleSelectChange(e){
        var value = e.target.value;
        this.setState({ msgTo:  value});
    }

    renderOption(option){
        return (
            <option key={option.id} value={option.value}>{ option.label }</option>
        );
    }

    renderUserSelection(){
        //let options = this.state.selectOptions !== undefined?  this.state.selectOptions.filter(it => it.name !== this.props.sender) : []
        let options = this.state.selectOptions !== undefined?  this.state.selectOptions : []
        return(
            <select className="selectBox"
                onChange={this.handleSelectChange.bind(this)}>
                <option key="empty" value=""></option>
                {options.map(option =>this.renderOption(option))}
            </select>
        );
    }

    sendMsg(){
        if ((this.state.msg === undefined) || 
            (this.state.msg ===null) || 
            (this.state.msg.length < 1)){
                alert(couterpart.translate('talk_msg_missing'));
                return;
        }

        if ((this.state.msgTo === undefined) || 
            (this.state.msgTo ===null) || 
            (this.state.msgTo.length < 1)){
                alert(couterpart.translate('talk_to_missing'));
                return;
        }

        TalkService.save(this.state).then(data => {
           alert(couterpart.translate("msg_created_ok"));
        });
    }

    render() {
        if (AuthenticationService.isUser() || AuthenticationService.isWorker()){
            return (<div>&nbsp;</div>)
        }
                
        return (
            <div className="col-12">
                <div className="row">
                    <div className="col-4 border-left border-top border-light-gray"><b>{couterpart.translate('talk_msg')}</b></div>
                    <div className="col-8 border-left border-top border-right border-light-gray">
                        <textarea name="name" className="form-control textArea" id="msg" 
                            placeholder={ couterpart.translate('talk_msg_holder') } 
                            value={this.state.msg === null? '' : this.state.msg} 
                            onChange={this.handleMsgChange.bind(this)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 border-left border-top border-light-gray"><b>{couterpart.translate('talk_to')}</b></div>
                    <div className="col-8 border-left border-top border-right border-light-gray">
                        { this.renderUserSelection() }
                    </div>                
                </div>
                <div className="row">
                    <div className="col-4 border-left border-top border-bottom border-light-gray">&nbsp;</div>
                    <div className="col-8 border border-light-gray">
                        <button className="myButton" type="button" 
                            onClick={this.sendMsg.bind(this)}>
                            <IoMdSend color={ICON_COLOR}/>
                            &nbsp;{couterpart.translate('button_send_to')}</button>
                    </div>                
                </div>        
            </div>
        );
    }
}

export default TalkDetails;